import { useEffect, useState } from 'react';
import { registerSW } from 'virtual:pwa-register';

/**
 * Control de versión de la app instalada.
 *
 * El service worker se actualiza solo (`autoUpdate` + `skipWaiting`), pero
 * además avisamos: sin aviso, alguien puede estar mirando una versión vieja
 * sin enterarse, que es exactamente lo que pasa con una planilla desactualizada.
 */
export function useActualizacion() {
  const [hayVersionNueva, setHayVersionNueva] = useState(false);
  const [listaSinConexion, setListaSinConexion] = useState(false);
  const [actualizar, setActualizar] = useState<(() => void) | null>(null);

  useEffect(() => {
    // En desarrollo no hay service worker registrado.
    if (!('serviceWorker' in navigator)) return;

    const actualizarSW = registerSW({
      immediate: true,
      onNeedRefresh() {
        setHayVersionNueva(true);
      },
      onOfflineReady() {
        setListaSinConexion(true);
      },
    });

    setActualizar(() => () => void actualizarSW(true));

    // Busca versiones nuevas al recuperar el foco y cada 30 minutos.
    const buscar = () => {
      void navigator.serviceWorker.getRegistration().then((r) => r?.update());
    };
    window.addEventListener('focus', buscar);
    const t = setInterval(buscar, 30 * 60 * 1000);

    return () => {
      window.removeEventListener('focus', buscar);
      clearInterval(t);
    };
  }, []);

  return { hayVersionNueva, listaSinConexion, actualizar };
}
